var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.path.match(/business/))?_c('BusinessSidebar'):(_vm.$route.path.match(/orders/))?_c('OrderSidebar'):(_vm.$route.path.match(/system/))?_c('SystemSidebar'):(_vm.$route.path.match(/users/))?_c('UserSidebar'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }